import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { ListarVistoriasComponent } from './components/listar-vistorias.component';
import { ListarModelosVistoriaResolver } from '../listar-modelos-vistoria/listar-modelos-vistoria.resolver';
import { ListarVistoriasResolver } from './listar-vistorias.resolver';

@NgModule({
  declarations: [
    ListarVistoriasComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    ListarModelosVistoriaResolver,
    ListarVistoriasResolver,
  ],
})
export class ListarVistoriasModule { }
